import { Decimal } from 'decimal.js';
import { LINE_NUMBER_FIELDS } from './line-number-fields.js';
const sameNumber = (formValue, storedValue) => new Decimal(Number(formValue)).equals(storedValue);
const lineNumberFieldNames = Object.keys(LINE_NUMBER_FIELDS);
function isLineUnchanged(line, stored) {
    return (line.productTreeId.toLowerCase() === stored.productTreeId.toLowerCase() &&
        lineNumberFieldNames.every((field) => sameNumber(line[field], stored[field])));
}
/** A form line without an id is new, and a stored line the form no longer lists is removed, so either counts as a change; order does not. */
export function haveCreditLinesChanged(formLines, storedLines) {
    if (formLines.length !== storedLines.length)
        return true;
    const storedById = new Map(storedLines.map((stored) => [stored.id.toLowerCase(), stored]));
    return formLines.some((line) => {
        const stored = line.id ? storedById.get(line.id.toLowerCase()) : undefined;
        return !stored || !isLineUnchanged(line, stored);
    });
}
//# sourceMappingURL=have-credit-lines-changed.js.map